function onEnrolleePayTransView_OnClick() {
    "use strict";
    getFileHtml('Enrollees.Offenders.Profile.Frp.Popup.Layout.htm', enrolleePopulatePopup);
}

function onEnrolleePayModal_OnClick(aParams, aData) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    var lData = { "aSecurityToken": lSecurityToken, "aSecurityContextId": -1, "aCallId": 1, "aAccountId": aData[0].SecurusEnrolleePayId, 'aSchema': gUserDetails.CurrentSchema.Name
    };
    
    callAjax("GetEnrolleePayInfo", lData, onTransReadOnSuccess, onEnrolleePayError, aData, false);
    

}

function onTransReadOnSuccess(aParams, aData) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    var lData = { "aSecurityToken": lSecurityToken, "aSecurityContextId": -1, "aCallId": 2, "aAccountId": aParams[0].SecurusEnrolleePayId, 'aSchema': gUserDetails.CurrentSchema.Name };

    callAjax("GetEnrolleePayInfo", lData, onTranSumReadOnSuccess, onEnrolleePayError, aData, false);
}


function onTranSumReadOnSuccess(aParams, aData) {
    "use strict";
    var lTranResults = JSON.parse(aParams),
        lSumResults = JSON.parse(aData);

    if (lTranResults.Transactions) {        
        uEnrolleePayListView_Init(lTranResults.Transactions);
        PopulateDetailView(lSumResults, {
            'UnbilledAmount': moneyFormatter,
            'TotalBalance': moneyFormatter,
            'PostedBalance': moneyFormatter,
            'LastActivityDate': nullFormatter,
            'InvoiceAmount': moneyFormatter
        }, 'uEnrolleePay');
    }
    
}

function uEnrolleePayListView_Init(aDataSource) {
    "use strict";
    var lColumns = [
          { 'id': 'ID', 'title': localizeWrapper('cEnrolleeId'), 'dataField': 'ID', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'formatMethod': null },
          { 'id': 'Type', 'title': localizeWrapper('cType'), 'dataField': 'Type', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': EnrolleePayTransTypeFormatter },
          { 'id': 'TranDate', 'title': localizeWrapper('cEnrolleePayTransactionDate'), 'dataField': 'TranDate', 'width': 'autoData', 'minWidth': 105, 'sortable': false, 'cssClass': null, 'formatMethod': null },
          { 'id': 'PaymentType', 'title': localizeWrapper('cEnrolleePayPaymentType'), 'dataField': 'PaymentType', 'width': 'autoData', 'minWidth': 90, 'sortable': false, 'cssClass': null, 'formatMethod': null },
          { 'id': 'RefNumber', 'title': localizeWrapper('cEnrolleePayRefNumber'), 'dataField': 'RefNumber', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': null },
          { 'id': 'Amount', 'title': localizeWrapper('cEnrolleePayAmount'), 'dataField': 'Amount', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': moneyFormatter },
          { 'id': 'TaxAmount', 'title': localizeWrapper('cEnrolleePayTaxAmount'), 'dataField': 'TaxAmount', 'width': 'autoData', 'minWidth': 90, 'sortable': false, 'cssClass': null, 'formatMethod': moneyFormatter },
          { 'id': 'TotalAmount', 'title': localizeWrapper('cEnrolleePayTotalAmount'), 'dataField': 'TotalAmount', 'width': 'autoData', 'minWidth': 90, 'sortable': false, 'cssClass': null, 'formatMethod': moneyFormatter }

    ];

    mEnrolleesControls.EnrolleeTransactionsListView = new sumo.controls.ListView(
            'uEnrolleeTransactionsListViews',
            'uEnrolleeTransactionsContent',
            { 'keyField': 'ID', 'keyFieldType': 'number', 'selectMethod': 'single', 'cssClass': 'VeritracksSelectListView', 'canUnselect': true, 'showHeader': true },
            lColumns);

    mEnrolleesControls.EnrolleeTransactionsListView.setDataSource(aDataSource);

}

function onEnrolleePayError(aData,d,c) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cEnrolleePayUpdateFailed'));
}

function enrolleePopulatePopup(aData) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar(),
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lBuilder = new SumoPredicateBuilder();

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'enrolleePayPopup_Dispose()'));
    DisplayPopup(localizeWrapper('cEnrolleePaySummaryFor') + lEnrollee.FullName + " (" + lEnrollee.PrimaryId + ")", aData, lButtonBar, true, false, true);
    $('.PopupWindow').addClass('CorrelationWidth');

    lBuilder.AddNewExpressionConditional('Id', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.OffenderProfile.AssemblyQualifiedName, lBuilder.RootExpression, 0, onEnrolleePayModal_OnClick, onEnrolleePayError, mEnrolleesData.OffenderCurrentId, null, 0);
    
    
}

function onEnrolleePayActive_OnSuccess(aParams, aData) {   
    mActivityNotification.addNotification(localizeWrapper('cEnrolleeComplete'));    
}

function onGetArchived_OnSuccess(aParams, aData) {
    var mData = JSON.parse(aData);
    if (mData.ErrorCode == 0 && mData.IsArchived) {
        //enroll in enrollee pay
        var mEnrolleeRequest = new ProcessRequest();
        mEnrolleeRequest.EnrolleeId = aParams.Enrollee.Id;
        mEnrolleeRequest.OrganizationId = aParams.Enrollee.OrganizationId;
        mEnrolleeRequest.OffenderPayFlag = true;
        mEnrolleeRequest.DailyRate = aParams.Offender.DailyRate;
        mEnrolleeRequest.Action = "RENEW";
        
        mActivityNotification.addNotification(localizeWrapper('cEnrolleePayUpdate'));
        WriteSingle(mEnrolleeRequest, onEnrolleePayActive_OnSuccess, onEnrolleePayError, aParams.Offender.DailyRate);
    }
}

function getEnrolleePayArchived(aEnrollee, aOffenderProfile) {    
    if (aOffenderProfile.SecurusEnrolleePayId != -1) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
        var lData = { "aSecurityToken": lSecurityToken, "aSecurityContextId": -1, "aCallId": 4, "aAccountId": aOffenderProfile.SecurusEnrolleePayId, 'aSchema': gUserDetails.CurrentSchema.Name };

        callAjax("GetEnrolleePayInfo", lData, onGetArchived_OnSuccess, onEnrolleePayError, { 'Enrollee': aEnrollee, 'Offender': aOffenderProfile }, false);
    }    
}

function disposeEnrolleePayProvisionedPopup() {
    ClosePopup();
    if ($("#uOffenderProfileOffenderPayFlagEdit").is(':checked')) {
        $("#uOffenderProfileOffenderPayFlagEdit").prop('checked', false);
    }
}

function getEnrolleeProvisioned_OnSuccess(aParams, aData) {
    if(typeof aData === "string" && aData !== "") { 
        aData = JSON.parse(aData)
    }
    if (aData.BillingAgencyCd == null || aData.BillingAgencyCd == "") {
        var lButtonBar = GenerateButtonCommandBar();
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'disposeEnrolleePayProvisionedPopup()'));
        DisplayPopup('Warning', '<span>Your organization is not setup for Enrollee Pay Program. Please contact account management to setup Enrollee Pay.</span>', lButtonBar, true, false, true);
    } else {
        uOffenderProfilePay_OnChange();
    }
}

function getEnrolleePayProvisioned(aOriId) {
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    var lData = { "aSecurityToken": lSecurityToken, "aSecurityContextId": -1, "aCallId": 3, "aAccountId": aOriId, 'aSchema': gUserDetails.CurrentSchema.Name };

    callAjax("GetEnrolleePayInfo", lData, getEnrolleeProvisioned_OnSuccess, onEnrolleePayError, null, false);

}

function enrolleePayPopup_Dispose(){
    "use strict";
    $('.PopupWindow').removeClass('CalendarWidth');
    ClosePopup();
    if (!isNullOrUndefined(mEnrolleesControls.EnrolleeTransactionsListView)) {
        mEnrolleesControls.EnrolleeTransactionsListView.dispose();
        mEnrolleesControls.EnrolleeTransactionsListView = null;
    }
}